import angular from 'angular';
import { onInputDirective } from './onInputDirective';

angular.module('sh.onInput', []).directive('shOnInput', onInputDirective);
